export default "__VITE_ASSET__6ce8a3ae__"